export default "__VITE_ASSET__DPf4QeYk__"